import { Logout, SetAuthToken, SetIsTokenSignIn } from 'src/constants/actionTypes'
import { authService } from 'src/services/AuthService'
import { Action } from 'src/utils/reduxUtils'
import { AuthState } from './types'

const getInitialState = (): AuthState => ({
  authToken:
    authService.getStoredAuthToken() ||
    // fallback to legacy keys for users who haven't migrated yet
    authService.getStoredOnboardingToken() ||
    authService.getStoredRecollectionToken(),
  isTokenSignIn: authService.getStoredIsTokenSignIn(),
})

export const authReducer = (
  state: AuthState = getInitialState(),
  action: Action<any>,
): AuthState => {
  switch (action.type) {
    case SetAuthToken.type.SUCCESS:
      return {
        ...state,
        authToken: action.payload,
      }
    case SetIsTokenSignIn.type.SUCCESS: {
      return {
        ...state,
        isTokenSignIn: action.payload,
      }
    }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
